import { useEffect, useState } from 'react'

const DISMISS_KEY = 'audio-cfg-demo-callout-dismissed'

/**
 * Dismissible "what can I do here?" card shown only on /editor/local-dev.
 * Three concrete hints — no modal, no tour library, no step counter. Once
 * dismissed, stays dismissed via localStorage so return visitors aren't
 * re-prompted.
 */
export function DemoCallout() {
  const [dismissed, setDismissed] = useState(true)

  useEffect(() => {
    if (typeof window === 'undefined') return
    setDismissed(localStorage.getItem(DISMISS_KEY) === '1')
  }, [])

  const handleDismiss = () => {
    setDismissed(true)
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // localStorage can throw in private mode; the in-memory state is
      // enough to hide the card for this session.
    }
  }

  if (dismissed) return null

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-40 pointer-events-auto max-w-md w-[calc(100%-2rem)]">
      <div className="bg-surface-raised/95 backdrop-blur-sm border border-brd-subtle rounded-xl shadow-high px-4 py-3">
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-semibold text-content-primary">
                Try the demo
              </h3>
              <button
                onClick={handleDismiss}
                aria-label="Dismiss demo hints"
                className="text-content-tertiary hover:text-content-primary transition-colors text-xs px-2 py-0.5 rounded hover:bg-surface-overlay"
              >
                Dismiss
              </button>
            </div>
            <ul className="text-xs text-content-secondary space-y-1 leading-relaxed">
              <li>
                <span className="text-content-primary font-medium">
                  Click a device
                </span>{' '}
                to inspect its ports and inputs/outputs.
              </li>
              <li>
                <span className="text-content-primary font-medium">
                  Drag from an output to an input
                </span>{' '}
                on another device to wire a new connection.
              </li>
              <li>
                <span className="text-content-primary font-medium">
                  Hit Auto-Map
                </span>{' '}
                in the toolbar to let the router fill in the rest.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
